export enum SideMenuItemName {
  Home = "Početna",
  Activities = "Aktivnosti",
  Patients = "Pacijenti",
  ProgramTemplates = "Programi",
}
